import React from 'react';
import { connect } from 'react-redux';
import styles from './Common.module.css'
import { noteActions } from '_actions';
import { bindActionCreators } from 'redux';
import { CancelButton, DBTextFieldObjective } from '_components';

class PatientCareCenterNoteObjectiveAsteriskRow extends React.Component {

    removeAsterisk() {
        this.props.removeChildRow(this.props.noteId, 'PTOBJECTIVEASTERISKS', 'OA', this.props.panel.OANO);
        if (!this.props.objUpdated) {
            this.props.updateBitField(this.props.noteId, 'PTNOTE', 'NTNO', this.props.pk, 'NTOBJECTIVEUPDATED', true);
        }
    }

    render() {
        return (
            <div>
                <div className={styles.textfield_row}>
                    <div className={styles.cell_wrapper}>
                        <span className={styles.flag} />
                    </div>
                    <div className={styles.cell_wrapper}>
                        <span className={styles.add_button} />
                    </div>
                    <div className={styles.cell_wrapper}>
                        <DBTextFieldObjective
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEASTERISKS'
                            entityKeyColumn='OANO'
                            entityKeyValue={this.props.id}
                            field='OAASTERISK'
                            placeholder='Function, ROM, MMT, or Subjective'
                            className={styles.column}
                        />
                    </div >
                    <div className={styles.cell_wrapper}>
                        <DBTextFieldObjective
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEASTERISKS'
                            entityKeyColumn='OANO'
                            entityKeyValue={this.props.id}
                            field='OAPREINT'
                            className={styles.column}
                        />
                    </div >
                    <div className={styles.cell_wrapper}>
                        <DBTextFieldObjective
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEASTERISKS'
                            entityKeyColumn='OANO'
                            entityKeyValue={this.props.id}
                            field='OAPOSTINT'
                            className={styles.column}
                        />
                    </div >
                    <div className={styles.cell_wrapper}>
                        <div className={styles.remove_button}>
                            <CancelButton title='Remove' size='extra-small' onClick={() => this.removeAsterisk()} />
                        </div>
                    </div >
                </div >
            </div>
        )
    }

}

function mapDispatchToProps(dispatch) {
    return {
        removeChildRow: bindActionCreators(noteActions.removeChildRow, dispatch),
        updateBitField: bindActionCreators(noteActions.updateBitField, dispatch)
    };
}

function mapStateToProps(state, ownprops) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let panel = state.entities.notes.PTOBJECTIVEASTERISKS[ownprops.id];
    let objUpdated = noteType !== 1 ? state.entities.notes.PTNOTE[pk].NTOBJECTIVEUPDATED : true;

    return {
        noteId,
        noteType,
        pk,
        panel,
        objUpdated
    };
}

const connectedPatientCareCenterNoteObjectiveAsteriskRow = connect(mapStateToProps, mapDispatchToProps)(PatientCareCenterNoteObjectiveAsteriskRow);
export { connectedPatientCareCenterNoteObjectiveAsteriskRow as PatientCareCenterNoteObjectiveAsteriskRow };

